import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Footer } from "@/components/Footer";

const LINES = [
  "Mirror is a thinking partner.",
  "It does not argue, judge, or preach. It asks questions.",
  "It helps you see what you already know but have been avoiding.",
  "This is not therapy. This is a conversation with yourself through a mirror.",
  "Type anything. There are no wrong answers, only starting points.",
];

export default function Onboarding() {
  const navigate = useNavigate();
  const { markOnboarded } = useAuth();
  const [step, setStep] = useState(0);
  const last = step >= LINES.length - 1;

  const next = async () => {
    if (!last) {
      setStep((s) => s + 1);
      return;
    }
    try {
      await api.post("/auth/onboarded");
    } catch (err) {
      console.error("Failed to persist onboarding state", err);
    }
    markOnboarded();
    navigate("/begin");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div
        data-testid="onboarding-screen"
        className="flex-1 flex flex-col items-center justify-center px-8 text-center cursor-pointer"
        onClick={next}
      >
      <div className="max-w-xl min-h-[8rem] flex items-center justify-center">
        <AnimatePresence mode="wait">
          <motion.p
            key={step}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 1, ease: "easeInOut" }}
            className="font-serif-display font-light text-2xl sm:text-3xl lg:text-4xl leading-snug tracking-tight"
          >
            {LINES[step]}
          </motion.p>
        </AnimatePresence>
      </div>

      <motion.button
        data-testid="onboarding-next-button"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.6 }}
        onClick={(e) => {
          e.stopPropagation();
          next();
        }}
        className="mt-16 px-10 py-3 rounded-full border border-[rgba(242,236,228,0.2)] text-sm tracking-[0.2em] uppercase hover:bg-[rgba(242,236,228,0.06)] transition-colors duration-700"
      >
        {last ? "Begin" : "Continue"}
      </motion.button>

      <div className="mt-10 flex gap-2">
        {LINES.map((_, i) => (
          <span
            key={i}
            className={`h-1 w-1 rounded-full transition-opacity duration-700 ${
              i <= step ? "bg-[var(--mirror-text)] opacity-70" : "bg-[var(--mirror-text)] opacity-20"
            }`}
          />
        ))}
      </div>
    </div>
      <Footer />
    </div>
  );
}
